import React from 'react';
import { CurrencyDollar } from '@phosphor-icons/react';

export const BillingSettingsCard = ({ billing, editBilling, setEditBilling, saving, saveBilling }) => (
  <div className="bg-white border border-[#E5E7EB] rounded-lg p-6 mb-8">
    <div className="flex items-center justify-between mb-4">
      <h2 className="font-outfit text-xl font-semibold text-[#09090B] flex items-center gap-2"><CurrencyDollar size={20} /> Billing Settings</h2>
      {!editBilling && (
        <button data-testid="edit-billing-button" onClick={() => setEditBilling({ ...billing })}
          className="px-4 py-2 text-sm bg-[#002FA7] text-white font-ibm font-semibold rounded-md hover:bg-[#00237D] transition-all">
          Edit Settings
        </button>
      )}
    </div>
    {editBilling ? (
      <div className="space-y-4">
        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className="block text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] mb-2 font-ibm">Price Per Case/Month</label>
            <input data-testid="billing-price-input" type="number" step="0.01" value={editBilling.price_per_case || ''} onChange={e => setEditBilling({...editBilling, price_per_case: parseFloat(e.target.value)})}
              className="w-full px-3 py-2.5 border border-[#E5E7EB] rounded-md font-ibm text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
          </div>
          <div>
            <label className="block text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] mb-2 font-ibm">Free Trial Cases</label>
            <input data-testid="billing-trial-input" type="number" value={editBilling.trial_cases || ''} onChange={e => setEditBilling({...editBilling, trial_cases: parseInt(e.target.value)})}
              className="w-full px-3 py-2.5 border border-[#E5E7EB] rounded-md font-ibm text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
          </div>
          <div>
            <label className="block text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] mb-2 font-ibm">Currency</label>
            <input data-testid="billing-currency-input" type="text" value={editBilling.currency || ''} onChange={e => setEditBilling({...editBilling, currency: e.target.value})}
              className="w-full px-3 py-2.5 border border-[#E5E7EB] rounded-md font-ibm text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
          </div>
        </div>
        <div className="flex gap-2 justify-end">
          <button onClick={() => setEditBilling(null)} className="px-4 py-2 border border-[#E5E7EB] text-[#09090B] font-ibm text-sm rounded-md hover:bg-[#F3F4F6] transition-all">Cancel</button>
          <button data-testid="save-billing-button" onClick={saveBilling} disabled={saving}
            className="px-4 py-2 bg-[#002FA7] text-white font-ibm text-sm font-semibold rounded-md hover:bg-[#00237D] disabled:opacity-50 transition-all">
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    ) : (
      <div className="grid grid-cols-3 gap-6">
        <div>
          <p className="text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm">Price Per Case</p>
          <p className="font-outfit text-xl font-bold text-[#09090B]">${billing.price_per_case}/mo</p>
        </div>
        <div>
          <p className="text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm">Trial Cases</p>
          <p className="font-outfit text-xl font-bold text-[#09090B]">{billing.trial_cases}</p>
        </div>
        <div>
          <p className="text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm">Currency</p>
          <p className="font-outfit text-xl font-bold text-[#09090B]">{billing.currency}</p>
        </div>
      </div>
    )}
  </div>
);
